export const scsmsTokens = {
  color: {
    primary: {
      50: "#FFF5EB",
      100: "#FFE5C7",
      200: "#FFCB8F",
      300: "#FFAA52",
      400: "#F8891F",
      500: "#F27400",
      600: "#D65E00",
      700: "#B84B00",
      800: "#923A00",
      900: "#6F2900",
    },
    secondary: {
      50: "#F4F5F5",
      100: "#E5E7E7",
      200: "#CDD0D0",
      300: "#ADB1B1",
      400: "#898E8E",
      500: "#6B7070",
      600: "#5A5F60",
      700: "#4B4F50",
      800: "#363A3B",
      900: "#242829",
    },
    accent: {
      orange: "#F27400",
      danger: "#C0392B",
      warning: "#D97706",
      success: "#2E7D32",
      info: "#546E7A",
    },
    neutral: {
      0: "#FFFFFF",
      50: "#F8F8F7",
      100: "#F0F1F0",
      200: "#E1E3E2",
      300: "#C9CCCB",
      400: "#9CA1A0",
      500: "#737978",
      600: "#5B6160",
      700: "#454A49",
      800: "#303433",
      900: "#1F2222",
    },
  },
  radius: { xs: 6, sm: 8, md: 10, lg: 12, xl: 16 },
  drawer: { width: 288, miniWidth: 84 },
};
